@if (display) {
  <div
    class="flex flex-middle m-b">
    <div class="ratio-1-1"
      style="width: 36px">
      <img class="rf"
        [image]="content.image">
    </div>
    <div class="p-l-2"
      style="width: calc(100% - 36px);">
      <p class="p2"
        *iCms="'text' of content"
        text>
      </p>
      @if (content?.cta_url && content?.cta_text) {
        <a class="button-inline-2 p2"
          [routerLink]="content.cta_url">
          <span
            *iCms="'cta_text' of content"
          text></span>
        </a>
      }
    </div>
  </div>
}